import Axios from 'axios';
import Qs from 'qs';

export default {

	//设备台账列表
	listPage(
		//这里是列表的名称
		community_id,
		device_type_id,
		name,
		device_model,
		brand,
		position,
		run_state,
		page,
		limit
	) {

		return Axios.get('/deviceManage/api/admin/device', {
			params: {

				community_id,
				device_type_id,
				name,
				device_model,
				brand,
				position,
				run_state,
				page,
				limit
			},
			paramsSerializer(params) {
				return Qs.stringify(params);
			}
		})
	},

	add(
		//需要新增的数据（数据名称）
		community_id,
		device_type_id,
		name,
		brand,
		position,
		device_sn,
		device_model,
		purchase_date,
		purchase_price,
		enable_date,
		depreciation_rate,
		year_limit,
		make_mill_id,
		repair_mill_id,
	) {
		return Axios.post('/deviceManage/api/admin/device/add', {
			//和上面新增的数据相同
			community_id,
			device_type_id,
			name,
			brand,
			position,
			device_sn,
			device_model,
			purchase_date,
			purchase_price,
			enable_date,
			depreciation_rate,
			year_limit,
			make_mill_id,
			repair_mill_id,
		})
	},

	//修改设备
	edit(
		id,
		community_id,
		device_type_id,
		name,
		brand,
		position,
		device_sn,
		device_model,
		purchase_date,
		purchase_price,
		enable_date,
		depreciation_rate,
		year_limit,
		make_mill_id,
		repair_mill_id,

	) {
		return Axios.patch(`/deviceManage/api/admin/device/${id}`, {
			community_id,
			device_type_id,
			name,
			brand,
			position,
			device_sn,
			device_model,
			purchase_date,
			purchase_price,
			enable_date,
			depreciation_rate,
			year_limit,
			make_mill_id,
			repair_mill_id,

		});
	},

	//删除
	del(
		//获取id
		id
	) {
		return Axios.delete(`/deviceManage/api/admin/device/{id}`, {
			//需要删除的内容
			data: {
				ids: [id]
			}
		})
	},
	//详情
	info(
		id
	) {
		return Axios.get(`/deviceManage/api/admin/device/${id}`);
	},

	list(param) {
		return Axios.get('/deviceManage/api/admin/device', {
			params: param,
			paramsSerializer(params) {
				return Qs.stringify(params);
			}
		})
	},

}